<template>
  <div class="wrapper">
    <CCHeader></CCHeader>
    <div class="data-wrapper">
      <CCSideBar></CCSideBar>
      <div class="main">
        <div class="report">
          <template v-if="status === 'loading'">
            <div class="message">
              Checking your permissions 
            </div>
            <div class="info">              
              The system is checking your permissions.
            </div> 
          </template>
          <template v-else-if="accessAlowed">
            <div class="message">
              Access Alowed
            </div>
            <div class="info">
              Great, you have the correct permissions to view <a v-bind:href="redirect">this page</a>.<br/>
              The <a v-bind:href="redirect">page</a> will be opened in seconds.
            </div>            
          </template>
          <template v-else>
            <div class="message">
              Access Denied
            </div>
            <div class="info">
              Sorry, you do not have permission to view <a v-bind:href="redirect">this page</a>.
            </div> 
          </template>          
        </div>
      </div>
    </div>    
  </div>
</template>

<script>

  import Vue from 'vue';
  import CCHeader from '@/components/common/CCHeader';
  import CCSideBar from '@/components/common/CCSideBar';
  import {loadCurentUserRoles} from "@/helpers/user";

  export default {
    name: "access-deny",
    components: {
      CCHeader,
      CCSideBar
    },
    data() {
      return {  
        redirect: this.$route.query.redirect,
        accessAlowed: false,
        status: 'init'      
      }
    },

    mounted() {
      this.accessAlowed = false;
      this.checkPermissions();          
    },

    watch: {
      accessAlowed: function(accessAlowed) {
        if( accessAlowed ) {
          this.$router.push(this.redirect);
        }
      }
    },

    methods: {
      getRequiredRoles: function(){
        let info = this.$router.resolve(this.$route.query.redirect);
        return _.get(info, 'route.meta.roles', []);
      },

      checkPermissions: function() {
        if( this.getRequiredRoles().length === 0 ) {
          this.accessAlowed = true;
        }
        else {
          if( this.status !== 'loading' ) {
            this.status = 'loading';
            loadCurentUserRoles().then((userRoles) => {
              let requiredRoles = this.getRequiredRoles();
              this.accessAlowed = _.difference(requiredRoles, userRoles).length === 0;
            })
            .finally(() => {
              this.status = 'loaded';
            })
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    display: grid;
    grid-template-areas:
            "header"
            "content"
            "footer";
    width: 100%;
    overflow-x: hidden;
  }

  .data-wrapper {
    display: flex;
  }

  .main {
    display: grid;
    grid-template-columns: auto;
    width: 100vw;
  }

  .report {
    background-color: #f0f0f0;
    max-width: 100%;
    height: 100vh;
    width: 100vw;
    position: relative;

    & > .message {
      font-size: 24px;
      margin-top: 15px;
      margin-bottom: 25px;
    }

    & > form {
      background-color: #f0f0f0;
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: center;

      & > .auth-form-data {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: center;

        & > div {
          margin-top: 10px;
          margin-bottom: 10px;

          & > input {
            margin-left: 30px;
          }
        }
      }

      & > div {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }

    &.sidebar-active {
      padding-left: 125px;
    }
  }

  .clear {
    clear: both;
  }

  @include mobile-only {
    .wrapper {
      display: grid;
      grid-template-areas:
              "header"
              "content"
              "footer";
    }
    grid-template-columns: 100vw;

    .main {
      grid-template-columns: 1fr;
    }

    .report {
      padding: 0;
      background-color: #fff;
      width: 100vw;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/common/AccessDeny.vue